
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"icon_pin_svg__a","d":"M207.71 315.63l-10.093 10.093a.947.947 0 11-1.34-1.34l10.093-10.093-6.094-6.094a.943.943 0 010-1.334l3.047-3.047a6.202 6.202 0 017.86-.75l6.272-6.27-1.178-1.178a.947.947 0 111.34-1.34l10.106 10.106a.947.947 0 11-1.34 1.34l-1.179-1.179-6.27 6.271a6.2 6.2 0 01-.75 7.862l-3.047 3.047a.943.943 0 01-1.335 0l-6.092-6.094zm10.09-6.104l6.2-6.2-5.327-5.326-6.2 6.199 5.328 5.327zm-1.077 8.07a4.357 4.357 0 000-6.163l-6.157-6.157a4.358 4.358 0 00-6.161 0L202 307.68 214.319 320l2.404-2.405z"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","transform":"translate(-190 -288)"}},[_c('mask',{attrs:{"id":"icon_pin_svg__b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#icon_pin_svg__a"}})]),_c('g',{attrs:{"fill":"#828282","mask":"url(#icon_pin_svg__b)"}},[_c('path',{attrs:{"d":"M190 288h44v44h-44z"}})])])])
          )
        }
      }
    